var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-tick",
      class: _vm.computedClass,
      style: _vm.componentStyle
    },
    [_c("div", { staticClass: "tick-content", style: _vm.contentStyle })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }